<template>
    <div>
        <auth-claim-list :type="2"></auth-claim-list>
    </div>
</template>

<script>
import AuthClaimList from '@/views/user/components/auth-claim-list';
export default {
    components:{AuthClaimList},
    data(){
        return{}
    }
}
</script>